module.exports = __webpack_public_path__ + "img/like.6ec029b.svg?v=1764327952164";